<template>
  
  <div class="container">
  
    <Cabecera></Cabecera>
   <b-breadcrumb>
    <b-breadcrumb-item href="#home"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    
  </b-breadcrumb>
    
       
   <b-card
   header=" "
    title="Elige la sección en la que se trabajará"
    img-src="https://micomidasegura.mx/img01.jpg"
    img-alt="Card Image"
    img-top
    tag="article"
    
    class="mb-3 mt-0 rounded"
  >

    <b-card-body class="text-center mt-0">
    

      <b-card-text class="justify-content-around">
        <div>
  <b-link href="#"><router-link to="/InicioUsuario"><h2>CARNE</h2></router-link></b-link>
</div>
 <div>
  <b-link href="#foo"><h2>VEGETALES</h2></b-link>
</div>
      </b-card-text>
      
     
    </b-card-body>
   </b-card>

<b-card>
 <b-card-body class="text-center">
      
      <b-card-title>hola!</b-card-title>

      <b-card-text>
        
      </b-card-text>
      
      <b-button variant="primary"><router-link to="/inicioUsuario" v-show="this.$localStorage.get('token')!=null">Herramientas</router-link></b-button>
    </b-card-body>
  </b-card>
   
  
  </div>
</template>

<script>
import Cabecera from './Cabecera'
import {mapState} from 'vuex'
import sesion from '../mixins/sesion'
import eliminar from '../mixins/eliminar'
export default {
  name: 'menuinicial',
  data () {
    return {

      msg: 'Welcome to Your Vue.js App',
      
    }
  },
  computed:{
        ...mapState(['mensaje'])
    },
  components:{
    Cabecera
  },
  mixins:[sesion,eliminar]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menuinicial.vue